import type { OnyxChip, OnyxOptional } from '@onyx/angular';
import { BaseSection } from '../enums/base-section';
import type { Base } from '../interfaces/base';

export const getBaseSections = (
  base: OnyxOptional<Base>,
): OnyxChip<BaseSection>[] => [
  {
    name: 'labels.assignedVehicles',
    value: BaseSection.ASSIGNED_VEHICLES,
    count: base?.assignedVehicles?.length,
  },
  {
    name: 'labels.assignedDrivers',
    value: BaseSection.ASSIGNED_DRIVERS,
    count: base?.assignedDrivers?.length,
  },
];
